var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolkadot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E6007A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3447 13.6147C22.5357 13.6147 24.3119 12.5816 24.3119 11.3073C24.3119 10.033 22.5357 9 20.3447 9C18.1536 9 16.3774 10.033 16.3774 11.3073C16.3774 12.5816 18.1536 13.6147 20.3447 13.6147Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3447 31C22.5357 31 24.3119 29.967 24.3119 28.6927C24.3119 27.4184 22.5357 26.3853 20.3447 26.3853C18.1536 26.3853 16.3774 27.4184 16.3774 28.6927C16.3774 29.967 18.1536 31 20.3447 31Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8161 16.8086C15.9116 14.9111 15.9045 12.8561 14.8002 12.2185C13.6959 11.5809 11.9126 12.6022 10.8171 14.4997C9.72154 16.3971 9.72865 18.4522 10.8329 19.0897C11.9372 19.7273 13.7205 18.706 14.8161 16.8086Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8706 25.5002C30.9661 23.6027 30.9596 21.548 29.856 20.9109C28.7525 20.2737 26.9698 21.2954 25.8743 23.1929C24.7788 25.0903 24.7853 27.145 25.8888 27.7822C26.9924 28.4193 28.7751 27.3976 29.8706 25.5002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8007 27.7816C15.905 27.144 15.9121 25.089 14.8166 23.1915C13.7211 21.2941 11.9378 20.2728 10.8335 20.9104C9.7292 21.5479 9.72209 23.603 10.8176 25.5004C11.9131 27.3979 13.6964 28.4192 14.8007 27.7816Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.857 19.0902C30.9605 18.4531 30.967 16.3984 29.8715 14.501C28.776 12.6035 26.9933 11.5818 25.8897 12.219C24.7862 12.8561 24.7797 14.9108 25.8752 16.8083C26.9707 18.7057 28.7534 19.7274 29.857 19.0902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadot);
export default __webpack_public_path__ + "static/media/polkadot.1c8b51d3d5fd83b173e7414c74cb88d3.svg";
export { ForwardRef as ReactComponent };